import { Link } from "react-router-dom";
import { Asterisk } from "lucide-react";
import { Seo } from "../components/Seo";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="max-w-[720px] mx-auto px-5 pt-24 pb-16 text-center">
      <Seo title="Page not found | U.CENTER Explained" description="This page does not exist, here are the ones that do." />
      <Asterisk size={32} className="spin-slow mx-auto mb-8" style={{ color: "var(--accent)" }} />
      <p className="font-serif-display font-light text-7xl md:text-8xl m-0" style={{ color: "var(--ink)" }}>404</p>
      <p className="text-lg mt-4 mb-10" style={{ color: "var(--ink-muted)" }}>
        That page doesn't exist. These do:
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {[
          { to: "/", label: "Homepage" },
          { to: "/what-is-ucenter", label: "What is U.CENTER?" },
          { to: "/what-is-utopia", label: "What is U-TOPIA?" },
          { to: "/how-to-verify", label: "How to verify" },
          { to: "/compensation-plan", label: "Compensation plan" },
          { to: "/glossary", label: "Glossary" },
        ].map((l) => (
          <Link key={l.to} to={l.to} data-testid={`404-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="outline-btn outline-btn--accent no-underline text-sm">
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
